/* eslint-disable no-prototype-builtins */
import axios from 'axios'
import { get } from 'lodash'
import { logEvent, LogLevel } from '@praxis/component-logging'
import { getUiServicesEndpoint } from './utils'
import { RawShipmentDetails } from 'common/types'

export const getShipmentsNeedReviewByVendorTloRefId: (
  vendorIds: number[],
  tloRefId: string,
) => Promise<{
  list: RawShipmentDetails[]
  pagination_metadata: {
    current_page: number
    total_count: number
    total_pages: number
  }
}> = async (vendorIds, tloRefId) => {
  const { key, url } = await getUiServicesEndpoint()
  // Fetch the complete TLO group. The review warning and capacity warning both
  // need the full group, not only shipments currently needing review.
  const endpoint = `${url}/v1/search/shipments?vendor_ids=${vendorIds}&tlo_ref_ids=${[
    tloRefId,
  ]}&key=${key}&page=1&per_page=100`
  try {
    const response = await axios({
      method: 'get',
      url: endpoint,
    })
    return {
      list: get(response, 'data.list', []),
      pagination_metadata: get(response, 'data.pagination_metadata', {
        current_page: 0,
        total_count: 0,
        total_pages: 0,
      }),
    }
  } catch (err: any) {
    const message = `Failed to load Shipments for TLO reference ID ${tloRefId}`

    logEvent(
      {
        message: JSON.stringify({
          endpoint: endpoint,
          error: err?.response?.data,
          message: message,
          type: 'REQUEST_FAILURE',
          user: localStorage?.userInfo,
        }),
        url: window.location.href,
      },
      { level: LogLevel.Error },
    )

    throw new Error(message)
  }
}
